import { type VariantProps, cva } from "class-variance-authority";
import type { ComponentPropsWithRef, ElementRef } from "react";
import { forwardRef } from "react";
import { cn } from "../../helpers/styles";

// ----------------------------------------------------------------------------------------------

export const Author = forwardRef<ElementRef<"div">, ComponentPropsWithRef<"div">>(
	({ children, className, ...props }, ref) => {
		return (
			<div ref={ref} className={cn("flex gap-md items-center", className)} {...props}>
				{children}
			</div>
		);
	},
);

Author.displayName = "Author";

// ----------------------------------------------------------------------------------------------

export const AuthorAvatar = forwardRef<
	ElementRef<"div">,
	ComponentPropsWithRef<"div"> & VariantProps<typeof authorAvatarvariants>
>(({ children, className, size, ...props }, ref) => {
	return (
		<div ref={ref} className={cn(authorAvatarvariants({ size }), className)} {...props}>
			{children}
		</div>
	);
});

AuthorAvatar.displayName = "AuthorAvatar";

const authorAvatarvariants = cva("", {
	variants: {
		size: {
			sm: "size-10",
			md: "size-12",
		},
	},
});

// ----------------------------------------------------------------------------------------------

export const AuthorContent = forwardRef<
	ElementRef<"div">,
	ComponentPropsWithRef<"div"> & VariantProps<typeof authorContentVariants>
>(({ children, className, size, ...props }, ref) => {
	return (
		<div ref={ref} className={cn(authorContentVariants({ size }), className)} {...props}>
			{children}
		</div>
	);
});

AuthorContent.displayName = "AuthorContent";

const authorContentVariants = cva("flex flex-col", {
	variants: {
		size: {
			sm: "text-sm",
			md: "text-md",
		},
	},
});

// ----------------------------------------------------------------------------------------------

export const AuthorTitle = forwardRef<ElementRef<"div">, ComponentPropsWithRef<"div">>(
	({ children, className, ...props }, ref) => {
		return (
			<div ref={ref} className={cn("font-semibold", className)} {...props}>
				{children}
			</div>
		);
	},
);

AuthorTitle.displayName = "AuthorTitle";

// ----------------------------------------------------------------------------------------------

export const AuthorSubtitle = forwardRef<ElementRef<"div">, ComponentPropsWithRef<"div">>(
	({ children, className, ...props }, ref) => {
		return (
			<div ref={ref} className={cn("text-gray-600", className)} {...props}>
				{children}
			</div>
		);
	},
);

AuthorSubtitle.displayName = "AuthorSubtitle";
